import React from 'react';

import { ADMIN_PDF_EXPORT_ANALYTICS_SOURCE, LazyPdfExportPage } from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminPdfExportRoute = () => <LazyPdfExportPage />;

AdminPdfExportRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_PDF_EXPORT_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
